// Central configuration for testbed vs live behaviour.
// These flags are baked in at build time via .env (REACT_APP_*).

export const isTestbed = () => process.env.REACT_APP_TESTBED === 'true';

export const getGoLiveDate = () => process.env.REACT_APP_GO_LIVE_DATE || null;

export const getRegistrationDeadline = () =>
  process.env.REACT_APP_REGISTRATION_DEADLINE || null;

export const isPastGoLive = () => {
  const d = getGoLiveDate();
  if (!d) return false;
  return Date.now() >= new Date(d).getTime();
};

// Registration is open unless we are on the testbed and past the deadline.
export const isRegistrationOpen = () => {
  if (!isTestbed()) return true; // live always allows registration
  const deadline = getRegistrationDeadline();
  if (!deadline) return true;
  return Date.now() < new Date(deadline).getTime();
};

// Show the "test platform" banner only on the testbed and before go-live.
export const shouldShowTestbedBanner = () => isTestbed() && !isPastGoLive();

export const canCreateTestUsers = () => isTestbed();

export const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
    timeZoneName: 'short',
  });
};
